import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=65011d5e"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports